import Repository from "./Repository";

export default {
  testAuth (headers) {
    const config = {
      headers: {
        lineToken: headers.lineToken,
        idToken: headers.idToken,
      },
    };
    return Repository.get(`/testAuth`, config);
  },
}
